import SiteMapPage from "components/siteMap/SiteMapPage"
import { GetStaticProps } from "next"
import { useTranslations } from "next-intl"
import { NextSeo } from "next-seo"
import React from "react"

const SiteMap = () => {
  const t = useTranslations("headerMenu")
  return (
    <>
      <NextSeo
        title={t("siteMap")}
        openGraph={{
          title: t("siteMap"),
        }}
      />
      <SiteMapPage />
    </>
  )
}

export const getStaticProps: GetStaticProps = async ({ locale }) => {
  return {
    props: {
      messages: (await import(`../../messages/${locale}.json`)).default,
    },
    revalidate: 60,
  }
}

export default SiteMap
